import M from 'materialize-css';

const NAVIGATION_DRAWER = "#navigation-drawer";

export const initNavigationDrawer = () => {
  const elem = document.querySelector(NAVIGATION_DRAWER);
  M.Sidenav.init(elem);
}

export const openDrawer = () => {
  const elem = document.querySelector(NAVIGATION_DRAWER);
  const instance = M.Sidenav.getInstance(elem);
  if (!instance)
    return;

  instance.open();
}